import React, { useRef} from 'react';
import { useUser } from '@lore/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import ParentLayout from '../EditLayout';
import Form from './Form';
import Urls from '../Urls';

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialLocationState = useRef(location.state);

  const currentUser = useUser();

  const onExit = () => {
    const returnPath = initialLocationState.current?.returnPath
      || Urls(currentUser).PROFILE_EDIT;
    navigate(returnPath);
  };

  return (
    <ParentLayout
      page="Sites"
      title={`${currentUser.data.firstName ? `Hi ${currentUser.data.firstName}! ` : ''} Please share your school or site so we can find relevant partners and opportunities for you.`}
      description={(
        <>
          Work at multiple locations? Select all that apply. Based at a district office? Choose the
          district name or the site you collaborate with most.
        </>
      )}
    >
      <Form
        user={currentUser}
        // navigation={(
        //   <Navigation v5={true} activeStep={2} steps={16}/>
        // )}
        // onPrevious={(newData) => history.push(Urls(offer).DESCRIPTION)}
        // onNext={(newData) => history.push(Urls(offer).OBJECTIVES)}
        // onSkip={() => history.push(Urls(offer).OBJECTIVES)}
        onExit={onExit}
      />
    </ParentLayout>
  );
};
